import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface ErrorWorkoutProps {
  onNavigateBack: () => void;
}

export default function ErrorWorkout({ onNavigateBack }: ErrorWorkoutProps) {
  return (
    <div className="container max-w-md mx-auto p-4">
      <Card>
        <CardContent className="pt-6">
          <div className="text-center">
            <div className="bg-red-100 text-red-800 p-4 rounded-lg mb-4">
              <p>Failed to load workout</p>
            </div>
            <Button onClick={onNavigateBack} variant="outline">
              Back to Workouts
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
